export default __webpack_public_path__ + "static/Strategy-919e8ec7db66ff3c60ac623dba14cf37.webp";